
import { Button } from "@/components/ui/button";
import { EditUserDialog } from "../EditUserDialog";
import { Lock, Trash2 } from "lucide-react";
import { SchoolUser } from "@/types/users";

interface UserActionsProps {
  user: SchoolUser & {
    hasUnpaidBills?: boolean;
    hasActiveSubscription?: boolean;
  };
  onDelete: (user: SchoolUser) => void;
  onUserUpdated: () => void;
}

export const UserActions = ({ user, onDelete, onUserUpdated }: UserActionsProps) => {
  return (
    <div className="flex items-center gap-2">
      <EditUserDialog
        userId={user.id}
        initialValues={user}
        onUserUpdated={onUserUpdated}
      />
      {user.hasUnpaidBills || user.hasActiveSubscription ? (
        <Button
          variant="ghost"
          size="icon"
          disabled
          title={
            user.hasUnpaidBills
              ? "Cannot delete user with unpaid bills"
              : "Cannot delete user with active subscription"
          }
        >
          <Lock className="h-4 w-4 text-gray-400" />
        </Button>
      ) : (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onDelete(user)}
        >
          <Trash2 className="h-4 w-4 text-red-500" />
        </Button>
      )}
    </div>
  );
};
